/**
 * Cross-domain advertising reference data (support + placement option lists).
 * Lives in `shared/` because multiple features (spaces, packages, …) resolve labels
 * from these — `shared/` is the architectural floor any feature may import.
 */

export const supportNames = [
  { label: 'Activation Area', value: 'ACTIVATION_AREA' },
  { label: 'Backlit Column', value: 'BACKLIT_COLUMN' },
  { label: 'Backlit Panel', value: 'BACKLIT_PANEL' },
  { label: 'Balustrades', value: 'BALUSTRADES' },
  { label: 'Billboard', value: 'BILLBOARD' },
  { label: 'Boulevard Vitrines', value: 'BOULEVARD_VITRINES' },
  { label: 'Citylight', value: 'CITYLIGHT' },
  { label: 'Column', value: 'COLUMN' },
  { label: 'Cube', value: 'CUBE' },
  { label: 'Digital Screen', value: 'DIGITAL_SCREEN' },
  { label: 'Digital Standup Column', value: 'DIGITAL_STANDUP_COLUMN' },
  { label: 'Digital Totem', value: 'DIGITAL_TOTEM' },
  { label: 'Elevator Decoration', value: 'ELEVATOR_DECORATION' },
  { label: 'Elevator Doors', value: 'ELEVATOR_DOORS' },
  { label: 'Entrance Side Window', value: 'ENTRANCE_SIDE_WINDOW' },
  { label: 'Escalator', value: 'ESCALATOR' },
  { label: 'Escalator Backside', value: 'ESCALATOR_BACKSIDE' },
  { label: 'Facade Banner', value: 'FACADE_BANNER' },
  { label: 'Facade Decoration', value: 'FACADE_DECORATION' },
  { label: 'Floor Sticker', value: 'FLOOR_STICKER' },
  { label: 'Hanging Backlit', value: 'HANGING_BACKLIT' },
  { label: 'Hanging Flag', value: 'HANGING_FLAG' },
  { label: 'Mesh', value: 'MESH' },
  { label: 'Panoramic Elevator Facade', value: 'PANORAMIC_ELEVATOR_FACADE' },
  { label: 'Parking Barriers', value: 'PARKING_BARRIERS' },
  { label: 'Parking Flags', value: 'PARKING_FLAGS' },
  { label: 'Poster Frame', value: 'POSTER_FRAME' },
  { label: 'Prism', value: 'PRISM' },
  { label: 'Radio Spot', value: 'RADIO_SPOT' },
  { label: 'Rotating Entrance Door Mockup', value: 'ROTATING_ENTRANCE_DOOR_MOCKUP' },
  { label: 'Rotating Entrance Doors', value: 'ROTATING_ENTRANCE_DOORS' },
  { label: 'Sliding Entrance Doors', value: 'SLIDING_ENTRANCE_DOORS' },
  { label: 'Special Project', value: 'SPECIAL_PROJECT' },
  { label: 'Standup Column', value: 'STANDUP_COLUMN' },
  { label: 'Swing Entrance Doors', value: 'SWING_ENTRANCE_DOORS' },
  { label: 'Table Sticker', value: 'TABLE_STICKER' },
  { label: 'Toilet Door', value: 'TOILET_DOOR' },
  { label: 'Toilet Mirror', value: 'TOILET_MIRROR' },
  { label: 'Travelator', value: 'TRAVELATOR' },
  { label: 'Wall Banner', value: 'WALL_BANNER' },
];

export const placementAreas = [
  { label: 'Atrium', value: 'ATRIUM' },
  { label: 'Corridor', value: 'CORRIDOR' },
  { label: 'Entrance Area', value: 'ENTRANCE_AREA' },
  { label: 'Facade', value: 'FACADE' },
  { label: 'Food Court', value: 'FOOD_COURT' },
  { label: 'Hypermarket Corridor', value: 'HYPERMARKET_CORRIDOR' },
  { label: 'Outdoor', value: 'OUTDOOR' },
  { label: 'Outdoor Parking', value: 'OUTDOOR_PARKING' },
  { label: 'Toilet', value: 'TOILET' },
  { label: 'Toilet Area', value: 'TOILET_AREA' },
  { label: 'Underground Parking', value: 'UNDERGROUND_PARKING' },
  { label: 'Elevator', value: 'ELEVATOR' },
  { label: 'Terrace', value: 'TERRACE' },
];

export const materialTypes = [
  {
    label: 'Laminated vinyl sticker removable adhesive',
    value: 'LAMINATED_VINYL_STICKER_REMOVABLE_ADHESIVE',
  },
  {
    label: 'Laminated vinyl sticker permanent adhesive',
    value: 'LAMINATED_VINYL_STICKER_PERMANENT_ADHESIVE',
  },
  { label: 'Vinyl sticker permanent adhesive', value: 'VINYL_STICKER_PERMANENT_ADHESIVE' },
  { label: 'Textile', value: 'TEXTILE' },
  { label: 'Film backlit', value: 'BACKLIT_FILM' },
  { label: 'Vinyl Banner', value: 'VINYL_BANNER' },
  { label: 'Vinyl Banner Backlit Coated', value: 'VINYL_BANNER_BACKLIT_COATED' },
  { label: 'Vinyl Banner Blockout printed front and back', value: 'VINYL_BANNER_BLOCKOUT' },
  { label: 'Forex', value: 'FOREX' },
  { label: 'Mesh', value: 'MESH' },
  { label: 'Special', value: 'SPECIAL' },
  { label: 'Windows Graphics', value: 'WINDOWS_GRAPHICS' },
  { label: 'mp4 / jpg', value: 'MEDIA_FORMAT' },
  { label: 'Paper', value: 'PAPER' },
  {
    label: 'Floor Graphics vinyl sticker removable laminated',
    value: 'FLOOR_GRAPHICS_VINYL_STICKER_REMOVABLE_ADHESIVE',
  },
  {
    label: 'Forex 5 mm with Laminated vinyl sticker permanent adhesive',
    value: 'FOREX_LAMINATED_VINYL_STICKER_PERMANENT_ADHESIVE',
  },
  {
    label: 'Vinyl sticker sandwich',
    value: 'VINYL_STICKER_SANDWICH',
  },
];

export * from './appConstants';
